import { useState } from "react";
import { Box, IconButton, MenuItem, Tooltip } from "@mui/material";
import GitHubIcon from "@mui/icons-material/GitHub";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import PestControlIcon from "@mui/icons-material/PestControl";
import SyncAltIcon from "@mui/icons-material/SyncAlt";

const GitHubActions = ({ versionURI }) => {
  const [openDropdown, setOpenDropdown] = useState(false);

  // github action icons data
  const data = [
    {
      title: "Change URI",
      icon: <SyncAltIcon fontSize="20" />,
      link: `https://github.com/OpenITI/Annotation/issues/new?assignees=&labels=URI+change+suggestion&template=change-uri.md&title=${versionURI}`,
    },
    {
      title: "Full text quality issue",
      icon: <PestControlIcon fontSize="20" />,
      link: `https://github.com/OpenITI/Annotation/issues/new?assignees=&labels=text+quality&template=text-quality-issue-.md&title=${versionURI}`,
    },
    {
      title: "Resport text tagged",
      icon: <LocalOfferIcon fontSize="20" />,
      link: `https://github.com/OpenITI/Annotation/issues/new?assignees=&labels=text+tagged&template=submission-report--for-pull-requests-.md&title=${versionURI}`,
    },
    {
      title: "Report text in progress",
      icon: <FormatListBulletedIcon fontSize="20" />,
      link: `https://github.com/OpenITI/Annotation/issues/new?assignees=&labels=in+progress&template=in-progress.md&title=IN+PROGRESS: ${versionURI}`,
    },
    {
      title: "Request change of primary text",
      icon: <AutorenewIcon fontSize="20" />,
      link: `https://github.com/OpenITI/Annotation/issues/new?assignees=&labels=PRI+%2526+SEC+Versions&template=pri-vs-sec.md&title=${versionURI}`,
    },
  ];

  return (
    <Box className={"github-actions"}>
      <Tooltip title={openDropdown ? "" : "Click to see GitHub options"}>
        <IconButton
          onMouseEnter={() => setOpenDropdown(true)}
          onMouseLeave={() => setOpenDropdown(false)}
          size={"small"}
          color={"neutral"}
          sx={{ p: 0 }}
        >
          <GitHubIcon sx={{ fontSize: "18px" }} />
          {openDropdown ? (
            <Box
              sx={{
                position: "absolute",
                bgcolor: "white",
                top: "50%",
                right: "100%",
                transform: "translateY(-50%)",
                zIndex: "99999",
                boxShadow: "0px 0px 5px 0px grey",
                display: "flex",
                width: "max-content",
              }}
            >
              {data.map((item, index) => (
                <Tooltip title={item.title} placement="top" key={index}>
                  <a rel="noreferrer" target="_blank" href={item.link}>
                    <MenuItem
                      sx={{
                        height: "30px",
                        width: "30px",
                        display: "flex",
                        justifyContent: "center",
                        justifyItems: "center",
                        color: "#7593af !important",
                      }}
                    >
                      {item.icon}
                    </MenuItem>
                  </a>
                </Tooltip>
              ))}
            </Box>
          ) : (
            ""
          )}
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default GitHubActions;
